import axios from 'axios'
import Vue from 'vue'
import router from '../routes/router'
import swal from 'sweetalert2'

var api = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json',
        'accept': 'application/json'
    }
});

function successToast(msg) {
    Vue.prototype.$notify({
        message: msg,
        icon: 'fa fa-check',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: 'success',
        timeout: 6000
    })
}

function errorToast(msg) {
    Vue.prototype.$notify({
        message: msg,
        icon: 'fa fa-bell',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: 'danger',
        timeout: 6000
    })
}

let loader = null;

function showLoader(text) {
    loader = Vue.prototype.$loading({
        lock: true,
        text: text,
        // spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.85)'
    });
}

function hideLoader() {
    loader.close();
}

function getAuthUser() {
    let user = localStorage.getItem('app_user');
    return JSON.parse(user);
}

function getAuthTokens() {
    let tokens = localStorage.getItem('app_user_tokens');
    return (tokens) ? JSON.parse(tokens) : { token: null, refreshtoken: null }
}

function getHeaders() {
    let { token, refreshtoken } = getAuthTokens()
    return (token && refreshtoken) ? { headers: { token, refreshtoken } } : { headers: {} }
}

function handleError(error, shouldHideLoader = false) {
    // check if timeout
    if (error.code != 'ECONNABORTED') {
        if(error.response){
            // handle response related errors
            switch (error.response.status) {
                case 400: // Bad Request [Insufficient inputs]
                    swal({
                        title: "Bad Request!",
                        text: `Your request seems to be wrong, please contact your administrator.`,
                        confirmButtonClass: "btn btn-default btn-fill",
                        confirmButtonText: "Okay",
                        buttonsStyling: false,
                    })
                    break;
                case 401: // Unauthorized [ token expiry ]
                    swal({
                        title: "Your session has expired!",
                        text: `You will have to login again, proceed to login page.`,
                        showCancelButton: false,
                        confirmButtonClass: "btn btn-default btn-fill",
                        confirmButtonText: "Go to Login",
                        buttonsStyling: false,
                        type: 'error'
                    }).
                    then(result => {
                        router.push('/auth/logout')
                    })
                    break;
                case 403: // Forbidden Request [Insufficient Privileges]
                    swal({
                        title: "Unauthorized!",
                        text: `You do not have sufficient privileges to complete the requested action, please contact your administrator.`,
                        confirmButtonClass: "btn btn-default btn-fill",
                        confirmButtonText: "Okay",
                        buttonsStyling: false,
                    })
                    break;
                case 404: // Not Found 
                    swal({
                        title: "Not Found!",
                        text: `Your requested resources seems to be missing, please contact your administrator.`,
                        confirmButtonClass: "btn btn-default btn-fill",
                        confirmButtonText: "Okay",
                        buttonsStyling: false,
                    })
                    break;
                case 500: // Internal Server Error
                default:
                    errorToast(`Oops! ${error.response.data.message}`)
                    console.log("TCL: actions.handleError -> error.response", error.response)
                    break;
            }       
        }
        else {
            // handle other types of errors
            errorToast(`Oops! Something went wrong!`);
            console.log("handleError -> error", error)
        }
    }
    else {
        // handle timeout errors or cancelled by axios
        errorToast(`Oops! Server is not responding!`);
        console.error(error.message);
    }

    if (shouldHideLoader) hideLoader()
}

export default {
    // attempt to login to the system using email and password
    attemptAuth({ commit, dispatch }, { email, password }) {
        showLoader('Attempting Login!');
        api.post('/auth/', {
            mail: email,
            password: password,
        })
            .then(response => {
                if (response.data.message == "Success"){
                    commit('setAuthTokens', response.headers)
                    if (response.data.data) {
                        response.data.data.roles = response.data.role
                    }
                    commit('setCurrentUser', JSON.stringify(response.data.data ? response.data.data : null))
                    successToast('Login Successful!')
                }
                else{
                    errorToast(`Oops! Something went wrong!`)
                }
                hideLoader()
            })
            .catch(err => {
                if(err.response)
                    errorToast(`Oops! ${err.response.data.message}`)
                console.log('error', err.response)
                hideLoader()
            })
    },

    // forgot Password
    forgotPassword({ commit, dispatch }, { email }) {
        showLoader('Resetting Password!');
        api.get(`/admin/users/password/reset?mail=${email}`)
            .then(response => {
                successToast('Password Reset Successful, Please check your email!')
                router.push('/auth/login')
                hideLoader()
            })
            .catch(err => {
                errorToast(`Oops! ${err.response.data.message}`)
                console.log(err.response)
                hideLoader()
            })
    },

    // attempt to update User Password
    updatePassword({ commit, dispatch }, payload) {

        showLoader('Updating password...');
        api.put('/admin/users', payload, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                // console.log(response.data);
                if (response.data.data) {
                    response.data.data.roles = response.data.role
                }
                // Vue.prototype.$currentUser = response.data.data ? response.data.data : null
                // commit('setCurrentUser', JSON.stringify(response.data.data ? response.data.data : null))
                successToast(response.data.message)
                hideLoader()
            })
            .catch(err => {
                errorToast(`Oops! ${err.response.data.message}`)
                console.log(err.response)
                hideLoader()
            })
    },

    // reset password to default by admin
    resetPassword({ dispatch, commit }, payload) {
        let { token, refreshtoken } = getAuthTokens()

        showLoader('Updating password...');
        api.put('admin/users/pwd/reset', payload, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                // if (response.data.data) {
                //     response.data.data.roles = response.data.role
                // }
                // Vue.prototype.$currentUser = response.data.data ? response.data.data : null
                // commit('setCurrentUser', JSON.stringify(response.data.data ? response.data.data : null))
                successToast(response.data.message)
                hideLoader()
            })
            .catch(err => {
                errorToast(`Oops! ${err.response.data.message}`)
                console.log(err.response)
                hideLoader()
            })
    },

    // GET Dashboard Numbers based on role
    getDashboard({ commit }, payload) {
        api.get(`/admin/miscs/v1/dashboard`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setDashboard', response.data.data ? response.data.data : [])
            })
            .catch(error => handleError(error, false))
    },

    // GET all Permissions
    getPermissions({ commit }) {
        api.get(`/admin/permissions`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setPermissions', response.data.data ? response.data.data : [])
            })
            .catch(error => handleError(error, false))
    },
    // GET all departments
    getDepartments({ commit }) {
        api.get(`/admin/miscs/departments`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setDepartments', response.data.data.value)
            })
            .catch(error => handleError(error, false))
    },
    // GET all deaneries
    getDeaneries({ commit }) {
        api.get(`/admin/miscs/deaneries`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setDeaneries', response.data.data.value)
            })
            .catch(error => handleError(error, false))
    },
    // GET all salutations
    getSalutations({ commit }) {
        api.get(`/admin/miscs/salutations`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setSalutations', response.data.data.value)
            })
            .catch(error => handleError(error, false))
    },
    // GET all designations
    getDesignations({ commit }) {
        api.get(`/admin/miscs/designations`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setDesignations', response.data.data.value)
            })
            .catch(error => handleError(error, false))
    },
    // GET all programmeTypes
    getProgrammeTypes({ commit }) {
        api.get(`/admin/miscs/programme-types`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setProgrammeTypes', response.data.data.value)
            })
            .catch(error => handleError(error, false))
    },
    // GET all topics
    getTopics({ commit }) {
        api.get(`/admin/miscs/notificationTopics`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setTopics', response.data.data.value)
            })
            .catch(error => handleError(error, false))
    },
    // GET all batches
    getBatches({ commit }) {
        api.get(`/admin/miscs/v1/batches`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setBatches', response.data.data)
            })
            .catch(error => handleError(error, false))
    },
    // GET Students by Batches
    async getStudentsByBatches({ commit }, payload) {
        let { token, refreshtoken } = getAuthTokens()
        let reqHeaders = { headers: { token, refreshtoken } }

        try {
            let response = await api.post(`/admin/users/students/batches`, payload, reqHeaders)
            commit('setAuthTokens', response.headers)
            return response.data.data ? response.data.data : []
        }
        catch (error) {
            handleError(error, false)
        }
    },
    // GET Teachers by Departments
    async getTeachersByDepartments({ commit }, payload) {
        let { token, refreshtoken } = getAuthTokens()
        let reqHeaders = { headers: { token, refreshtoken } }

        try {
            let response = await api.post(`/admin/users/teachers/departments`, payload, reqHeaders)
            commit('setAuthTokens', response.headers)
            return response.data.data ? response.data.data : []
        }
        catch (error) {
            handleError(error, false)
        }
    },

    // Roles CRUD
    // GET all Roles
    getRoles({ commit }) {
        showLoader(`Getting Roles...!`);
        api.get(`/admin/roles`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setRoles', response.data.data ? response.data.data : [])
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // GET a Role by slug
    getRole({ commit }, slug) {
        api.get(`/admin/roles/${slug}`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setRole', response.data.data ? response.data.data : null)
            })
            .catch(error => handleError(error, false))
    },
    // ADD a new Role
    createRole({ dispatch, commit }, payload) {
        showLoader(`Creating a new role: ${payload.title}`);
        api.post(`/admin/roles`, payload, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getRoles')
                successToast(`${response.data.message}`)
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // DELETE an existing Role
    deleteRole({ dispatch, commit }, payload) {
        let { token, refreshtoken } = getAuthTokens()
        let config = {
            data: { slug: payload },
            headers: { token, refreshtoken },
        }

        showLoader(`Loading...!`);

        api.delete(`/admin/roles`, config)
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getRoles')
                successToast(`${response.data.message}`)
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // UPDATE an existing Role
    updateRole({ dispatch, commit }, payload) {
        showLoader(`Updating role: ${payload.title}`);
        api.put(`/admin/roles`, payload, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getRoles')
                successToast(`${response.data.message}`)
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },


    // Miscs CRUD
    // GET all Miscs
    getMiscs({ commit }) {


        showLoader(`Getting Miscs...!`);

        api.get(`/admin/miscs`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setMiscs', response.data.data ? response.data.data : [])
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // GET a Misc by slug
    getMisc({ commit }, slug) {


        api.get(`/admin/miscs/${slug}`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setMisc', response.data.data ? response.data.data : null)
            })
            .catch(error => handleError(error, true))
    },
    // ADD a new Misc
    createMisc({ dispatch, commit }, payload) {


        showLoader(`Creating a new misc: ${payload.feature}`);

        api.post(`/admin/miscs`, payload, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getMiscs')
                successToast(`${response.data.message}`)
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // DELETE an existing Misc
    deleteMisc({ dispatch, commit }, payload) {
        let { token, refreshtoken } = getAuthTokens()
        let config = {
            data: { feature: payload },
            headers: { token, refreshtoken },
        }

        showLoader(`Loading...!`);

        api.delete(`/admin/miscs`, config)
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getMiscs')
                successToast(`${response.data.message}`)
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // UPDATE an existing Misc
    updateMisc({ dispatch, commit }, payload) {


        showLoader(`Updating misc: ${payload.feature}`);

        api.put(`/admin/miscs`, payload, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getMiscs')
                successToast(`${response.data.message}`)
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },

    // Courses CRUD
    // GET all Courses
    getCourses({ commit }) {


        showLoader(`Getting Programmes...!`);

        api.get(`/admin/courses`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setCourses', response.data.data ? response.data.data : [])
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // GET a Course by slug
    getCourse({ commit }, slug) {
        api.get(`/admin/courses/${slug}`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setCourse', response.data.data ? response.data.data : null)
            })
            .catch(error => handleError(error, false))
    },
    // ADD a new Course
    createCourse({ dispatch, commit }, payload) {


        showLoader(`Creating a new programme: ${payload.title}`);

        api.post(`/admin/courses`, payload, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getCourses')
                successToast(`${response.data.message}`)
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // DELETE an existing Course
    deleteCourse({ dispatch, commit }, payload) {
        let { token, refreshtoken } = getAuthTokens()
        let config = {
            data: { slug: payload },
            headers: { token, refreshtoken },
        }

        showLoader(`Loading...!`);

        api.delete(`/admin/courses`, config)
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getCourses')
                successToast(`${response.data.message}`)
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // UPDATE an existing Course
    updateCourse({ dispatch, commit }, payload) {


        showLoader(`Updating programme: ${payload.title}`);

        api.put(`/admin/courses`, payload, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getCourses')
                successToast(`${response.data.message}`)
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },

    // Papers CRUD
    // GET all Papers
    getPapers({ commit }) {
        showLoader(`Getting Courses...!`);

        api.get(`/admin/papers`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setPapers', response.data.data ? response.data.data : [])
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // GET a Paper by slug
    getPaper({ commit }, slug) {
        commit('setPaper', null)

        api.get(`/admin/papers/${slug}`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setPaper', response.data.data ? response.data.data : null)
            })
            .catch(error => handleError(error, false))
    },
    // ADD a new Paper
    createPaper({ dispatch, commit }, payload) {
        showLoader(`Creating a new course: ${payload.title}`);

        api.post(`/admin/papers`, payload, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                router.push('/CBCS/papers/manage')
                successToast(`${response.data.message}`)
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // DELETE an existing Paper
    deletePaper({ dispatch, commit }, payload) {
        let { token, refreshtoken } = getAuthTokens()
        let config = {
            data: { slug: payload },
            headers: { token, refreshtoken },
        }

        showLoader(`Loading...!`);

        api.delete(`/admin/papers`, config)
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getPapers')
                successToast(`${response.data.message}`)
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // UPDATE an existing Paper
    updatePaper({ dispatch, commit }, payload) {


        showLoader(`Updating course: ${payload.title}`);

        api.put(`/admin/papers`, payload, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getPapers')
                successToast(`${response.data.message}`)
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },


    // Students CRUD
    // GET all Students
    getStudents({ commit }, {page=1, per_page=10, search=null}) {

        showLoader(`Getting Students...!`);
        let query = (search !== '' && search !== null) ? `&search=${search}` : ''
        console.log(page, per_page, search, query);
        api.get(`/admin/users/students/paginated?page=${page}&count=${per_page}${query}`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setStudents', response.data.data ? response.data.data : [])
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    getAllStudents({ commit }) {

        // showLoader(`Getting All Students...!`);
        api.get(`/admin/users/students`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setAllStudents', response.data.data ? response.data.data : [])
                // hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // GET a Student by slug
    getStudent({ commit }, slug) {
        api.get(`/admin/users/students/${slug}`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setStudent', response.data.data ? response.data.data : null)
            })
            .catch(error => handleError(error, false))
    },
    // ADD a new Student
    createStudent({ dispatch, commit }, {payload, page, per_page, search}) {


        showLoader(`Creating a new student: ${payload.name}`);

        api.post(`/admin/users/students`, payload, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getStudents', {page, per_page, search})
                successToast(`${response.data.message}`)
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // DELETE an existing Student
    deleteStudent({ dispatch, commit }, {payload, page, per_page, search}) {
        let { token, refreshtoken } = getAuthTokens()
        let config = {
            data: { id: payload },
            headers: { token, refreshtoken },
        }

        showLoader(`Loading...!`);

        api.delete(`/admin/users/students`, config)
            .then(response => {
                commit('setAuthTokens', response.headers)
                // dispatch('getStudents')
                dispatch('getStudents', {page, per_page, search})
                successToast(`${response.data.message}`)
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // UPDATE an existing Student
    updateStudent({ dispatch, commit }, {payload, page, per_page, search}) {
        showLoader(`Updating student: ${payload.name}`);

        api.put(`/admin/users/students`, payload, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getStudents', {page, per_page, search})
                successToast(`${response.data.message}`)
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },


    // Teachers CRUD
    // GET all Teachers
    getTeachers({ commit }) {


        showLoader(`Getting Teachers...!`);

        api.get(`/admin/users/teachers`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setTeachers', response.data.data ? response.data.data : [])
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // GET a Teacher by slug
    getTeacher({ commit }, slug) {
        api.get(`/admin/users/teachers/${slug}`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setTeacher', response.data.data ? response.data.data : null)
            })
            .catch(error => handleError(error, false))
    },
    // ADD a new Teacher
    createTeacher({ dispatch, commit }, payload) {


        showLoader(`Creating a new teacher: ${payload.name}`);

        api.post(`/admin/users/teachers`, payload, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getTeachers')
                successToast(`${response.data.message}`)
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // DELETE an existing Teacher
    deleteTeacher({ dispatch, commit }, payload) {
        let { token, refreshtoken } = getAuthTokens()
        let config = {
            data: { id: payload },
            headers: { token, refreshtoken },
        }

        showLoader(`Loading...!`);

        api.delete(`/admin/users/teachers`, config)
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getTeachers')
                successToast(`${response.data.message}`)
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // UPDATE an existing Teacher
    updateTeacher({ dispatch, commit }, payload) {


        showLoader(`Updating teacher: ${payload.name}`);

        api.put(`/admin/users/teachers`, payload, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getTeachers')
                successToast(`${response.data.message}`)
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },

    // Programmes CRUD
    // GET all Programmes
    getProgrammes({ commit }) {


        showLoader(`Getting Programmes...!`);

        api.get(`/tukio/programmes/all`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setProgrammes', response.data.data ? response.data.data : [])
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // GET all Programmes
    getProgrammesData({ commit }) {


        showLoader(`Getting Programmes...!`);

        api.get(`/tukio/programmes/all`, getHeaders())
            .then(response => {
                let resp = {"message":"","data":[{"seating":{"limited":false,"current_seat":8,"max_seat":100},"paper":null,"department":"Humanities_UG","type":"individual","login":true,"pool":true,"batches":["2020 BA EPsS","2020 BA English (Honours)","2020 BA HEP","2020 BA HTJ","2020 BA JEEng","2020 BA JPCS","2020 BA JPEng","2020 BA JPsEng","2020 BA LLB","2020 BA PaPEng","2020 BA Visual Communication","2020 BBA","2020 BBA AM","2020 BBA Business Analytics","2020 BBA LLB","2020 BBA with CGMA","2020 BCA","2020 BCA with Analytics","2020 BCom","2020 BCom ACCA","2020 BCom Business Analytics","2020 BCom Hon","2020 BCom LLB","2020 BCom LSCM","2020 BCom Prof","2020 BCom Tourism","2020 BCom with CMA","2020 BSc (Honors) Forensic Science","2020 BSc BBG","2020 BSc CSME","2020 BSc CSMS","2020 BSc MBG","2020 BSc MSE","2020 BSc PMCS","2020 BSc PME","2020 BSc [BBB]","2019 BA EPsS","2019 BA HEP","2019 BA HTJ","2019 BA JEEng","2019 BA JPCS","2019 BA JPEng","2019 BA JPsEng","2019 BA LLB","2019 BBA","2019 BBA AM","2019 BBA Business Analytics","2019 BBA LLB","2019 BBA with CGMA","2019 BCA","2019 BCA with Analytics","2019 BCom","2019 BCom ACCA","2019 BCom Business Analytics","2019 BCom Hon","2019 BCom LLB","2019 BCom LSCM","2019 BCom Prof","2019 BCom Tourism","2019 BCom with CMA","2019 BSc (Honors) Forensic Science","2019 BSc BBG","2019 BSc CSME","2019 BSc CSMS","2019 BSc MBG","2019 BSc MSE","2019 BSc PMCS","2019 BSc PME","2019 BSc [BBB]"],"eventType":"group","events":[{"title":"Civil Service Exams Training","description":"Training to Civil Service aspirants to prepare for the UPSC Civil Service Exams","image":"https://kjc.sgp1.digitaloceanspaces.com/tukio/programmes/image-1606908118436.jpg","seating":{"limited":false,"current_seat":8,"max_seat":100},"paper":null,"department":"Humanities_UG","type":"individual","login":true,"pool":true,"visible":true,"min_participants":1,"max_participants":1,"permitted_enrollments":1,"open_date":"2020-11-30T18:30:00.000Z","close_date":"2020-12-09T18:30:00.000Z","start_date":"2020-12-01T18:30:00.000Z","end_date":"2020-12-09T18:30:00.000Z","price":20000,"venue":"Kristu Jayanti College","form":[],"coordinators":[{"_id":"5fc777c15e9142008453f39e","name":"Alna Mariya Issac","title":"Coordinator","designation":"MS","image":null,"phone":"9544974389","email":"alnamariya@kristujayanti.com"}],"slug":"civil-service-exams-training"}],"title":"Civil Service Exams Training","description":"Training to Civil Service aspirants to prepare for the UPSC Civil Service Exams","image":"https://kjc.sgp1.digitaloceanspaces.com/tukio/programmes/image-1606908118436.jpg","visible":true,"min_participants":1,"max_participants":1,"permitted_enrollments":1,"open_date":"2020-11-30T18:30:00.000Z","close_date":"2020-12-09T18:30:00.000Z","start_date":"2020-12-01T18:30:00.000Z","end_date":"2020-12-09T18:30:00.000Z","price":20000,"venue":"Kristu Jayanti College","form":[],"coordinators":[{"_id":"5fc777c15e9142008453f39e","name":"Alna Mariya Issac","title":"Coordinator","designation":"MS","image":null,"phone":"9544974389","email":"alnamariya@kristujayanti.com"}],"slug":"civil-service-exams-training"}]}
                commit('setAuthTokens', response.headers)
                commit('setProgrammes', resp.data ? resp.data : [])
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // GET a Programme by slug
    getProgramme({ commit }, slug) {
        let headers = getHeaders()

        showLoader(`Getting programme details  : ${slug}`);
        commit('setProgramme', null)
        api.get(`/tukio/programmes/${slug}`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setProgramme', response.data.data ? response.data.data : null)
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // GET a Programme by slug & batch
    getProgrammeByBatch({ commit }, {slug, batch}) {
        let headers = getHeaders()
        // console.log(slug, batch);
        showLoader(`Getting programme details of ${slug} for ${batch}`);
        api.get(`/tukio/programmes/programme/${batch}/${slug}`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setProgramme', response.data.data ? response.data.data : null)
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // ADD a new Programme
    createProgramme({ dispatch, commit }, payload) {


        showLoader(`Creating a new programme: ${payload.title}`);

        api.post(`/tukio/programmes`, payload, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getProgrammes')
                successToast(`${response.data.message}`)
                router.push('/programmes')
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // DELETE an existing Programme
    deleteProgramme({ dispatch, commit }, payload) {
        let { token, refreshtoken } = getAuthTokens()
        let config = {
            data: { slug: payload },
            headers: { token, refreshtoken },
        }

        showLoader(`Loading...!`);

        api.delete(`/tukio/programmes`, config)
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getProgrammes')
                successToast(`${response.data.message}`)
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // UPDATE an existing Programme
    updateProgramme({ dispatch, commit }, payload) {


        showLoader(`Updating programme: ${payload.title}`);

        api.put(`/tukio/programmes/${payload.slug}`, payload, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getProgrammes')
                successToast(`${response.data.message}`)
                router.push('/programmes')
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // Get Programme for LoggedIn Users
    // GET all Programmes
    getUserProgrammes({ commit }) {
        let { token, refreshtoken } = getAuthTokens()
        let headers = null
        if (token && refreshtoken)
            headers = { headers: { token, refreshtoken } }

        showLoader(`Getting Programmes...!`);

        api.get(`/tukio/programmes/`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setProgrammes', response.data.data ? response.data.data : [])
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },

    // GET a Event by slug
    getEvent({ commit }, slug) {
        // console.log(getHeaders());
        api.get(`/tukio/events/${slug}`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setEvent', response.data.data ? response.data.data : null)
            })
            .catch(error => handleError(error, false))
    },

    // GET all Programmes by Batch
    getUserProgrammesByBatch({ commit }, batch) {
        let { token, refreshtoken } = getAuthTokens()
        let headers = null
        if (token && refreshtoken)
            headers = { headers: { token, refreshtoken } }

        showLoader(`Getting Programmes for ${batch}...!`);

        api.get(`/tukio/programmes/batch/${batch}`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setProgrammes', response.data.data ? response.data.data : [])
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },

    // Create an new registration for event of programme as a whole
    createRegistration({ commit }, payload) {


        showLoader(`Creating a new registration...`);
        console.log(payload);
        api.post(`/tukio/users/register`, payload, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                successToast(`${response.data.message}`)
                router.go(-1)
                // router.push(`/register-${payload.programme.slug}`)
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // Get Registrations of a Logged In User
    getUserRegistrations({ commit }) {
        showLoader(`Fetching Registration...`);
        commit('setRegistrations', [])
        api.get(`/tukio/users/registrations`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setRegistrations', response.data.data ? response.data.data : [])
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // Get Programme Registrations
    getProgrammeRegistrations({ commit }, payload) {
        showLoader(`Fetching Registration...`);
        commit('setRegistrations', [])
        api.get(`/tukio/admin/registrations/programme/${payload}`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setRegistrations', response.data.data ? response.data.data : [])
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // Get Event Registrations
    getEventRegistrations({ commit }, payload) {
        showLoader(`Fetching Registration...`);
        commit('setRegistrations', [])
        api.get(`/tukio/admin/registrations/events/${payload}`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setRegistrations', response.data.data ? response.data.data : [])
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // DELETE an existing Registration
    deleteRegistration({ dispatch, commit }, payload) {
        let user = getAuthUser()
        let { token, refreshtoken } = getAuthTokens()
        let config = {
            data: { reg_id: payload.reg_id },
            headers: { token, refreshtoken },
        }

        showLoader(`Deleting ${payload.reg_id}...!`);

        if(user.roles.includes('admin')){
            // admin delete
            api.delete(`/tukio/users/registrations`, config)
                .then(response => {
                    commit('setAuthTokens', response.headers)
                    switch(payload.type){
                        case 'programme':
                            dispatch('getProgrammeRegistrations', payload.slug);
                            break;
                        case 'event':
                            dispatch('getEventRegistrations', payload.slug);
                            break;
                    }
                    successToast(`${response.data.message}`)
                    hideLoader()
                })
                .catch(error => handleError(error, true))
        }
        else{
            // user delete
            api.delete(`/tukio/users/registrations`, config)
                .then(response => {
                    commit('setAuthTokens', response.headers)
                    dispatch('getUserRegistrations')
                    successToast(`${response.data.message}`)
                    hideLoader()
                })
                .catch(error => handleError(error, true))
        }
        
    },

    // Search all Users
    searchUsers({ commit }, payload) {


        // showLoader(`Searching Users...!`);

        api.get(`/admin/users/search/${payload}`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setUsers', response.data.data ? response.data.data : [])
                // hideLoader()
            })
            .catch(error => handleError(error, false))
    },

    // News CRUD
    // Search all News
    searchNews({ commit }, payload) {

        showLoader(`Searching News...!`);

        api.get(`/glimpses/news/search/${payload}`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setNews', response.data.data ? response.data.data : [])
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // GET all News
    getNews({ commit }) {


        showLoader(`Getting News...!`);

        api.get(`/glimpses/news`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setNews', response.data.data ? response.data.data : [])
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // GET a News by slug
    getNew({ commit }, slug) {
        api.get(`/glimpses/news/${slug}`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setNew', response.data.data ? response.data.data : null)
            })
            .catch(error => handleError(error, false))
    },
    // ADD a new News
    createNews({ dispatch, commit }, payload) {


        showLoader(`Creating a news: ${payload.title}`);

        api.post(`/glimpses/news`, payload, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getNews')
                successToast(`${response.data.message}`)
                router.push('/glimpses/news')
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // DELETE an existing News
    deleteNews({ dispatch, commit }, payload) {
        let { token, refreshtoken } = getAuthTokens()
        let config = {
            data: { slug: payload },
            headers: { token, refreshtoken },
        }

        showLoader(`Loading...!`);

        api.delete(`/glimpses/news`, config)
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getNews')
                successToast(`${response.data.message}`)
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // UPDATE an existing News
    updateNews({ dispatch, commit }, payload) {

        showLoader(`Updating news: ${payload.title}`);
        api.put(`/glimpses/news/${payload.slug}`, payload, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getNews')
                successToast(`${response.data.message}`)
                router.push('/glimpses/news')
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // Approve an existing News
    approveNews({ dispatch, commit }, payload) {

        showLoader(`Approving news: ${payload.title}`);
        api.put(`/glimpses/news/status/${payload.slug}`, {status: true}, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getNews')
                successToast(`${response.data.message}`)
                router.push('/glimpses/news')
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },

    // Newsletters CRUD
    // GET all Volumes
    getVolumes({ commit }) {


        showLoader(`Getting Volumes...!`);

        api.get(`/glimpses/newsletter/volumes`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setVolumes', response.data.data ? response.data.data : [])
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // GET all NewsletterTree
    getNewsletterTree({ commit }) {


        showLoader(`Getting Tree...!`);

        api.get(`/glimpses/newsletter/tree`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setNewsletterTree', response.data.data ? response.data.data : [])
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // GET all NewslettersByVolume
    getNewslettersByVolume({ commit }, payload) {


        showLoader(`Getting Newsletters...!`);

        api.get(`/glimpses/newsletter/volumes/${payload}`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setNewsletters', response.data.data ? response.data.data : [])
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // GET all Newsletter By Volume & Issue
    getNewsletterByVolumeIssue({ commit }, payload) {


        showLoader(`Getting Newsletter Vol: ${payload.volume} Issue: ${payload.issue}...`);

        api.get(`/glimpses/newsletter/byvol/${payload.volume}/${payload.issue}`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setNewsletter', response.data.data ? response.data.data : [])
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // GET all Newsletters
    getNewsletters({ commit }) {


        showLoader(`Getting Newsletters...!`);

        api.get(`/glimpses/newsletter`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setNewsletters', response.data.data ? response.data.data : [])
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // GET a Newsletter Issue No by volume
    getIssueNo({ commit }, volume) {

        showLoader(`Getting Next Issue No...!`);

        api.get(`/glimpses/newsletter/next/issue/${volume}`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setIssueNo', response.data ? response.data.data.issue : null)
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // GET a Newsletter by id
    getNewsletter({ commit }, id) {


        showLoader(`Getting Newsletter...!`);

        api.get(`/glimpses/newsletter/${id}`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setNewsletter', response.data.data ? response.data.data : null)
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // ADD a newsletter Newsletters
    createNewsletter({ dispatch, commit }, payload) {


        showLoader(`Creating a newsletters: Vol: ${payload.volume} Issue: ${payload.issue}`);

        payload.featured_news = payload.featured_news._id
        payload.news = payload.news.map(item => item._id)

        api.post(`/glimpses/newsletter`, payload, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getNewsletters')
                successToast(`${response.data.message}`)
                router.push('/glimpses/newsletters')
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // DELETE an existing Newsletters
    deleteNewsletter({ dispatch, commit }, payload) {
        let { token, refreshtoken } = getAuthTokens()
        let config = {
            data: { slug: payload },
            headers: { token, refreshtoken },
        }

        showLoader(`Loading...!`);

        api.delete(`/glimpses/newsletter/${payload}`, config)
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getNewsletters')
                successToast(`${response.data.message}`)
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // UPDATE an existing Newsletters
    updateNewsletter({ dispatch, commit }, payload) {


        showLoader(`Updating newsletters: Vol: ${payload.volume} Issue: ${payload.issue}`);



        payload.featured_news = payload.featured_news._id
        payload.news = payload.news.map(item => item._id)

        // console.log(payload)

        api.put(`/glimpses/newsletter/${payload._id}`, payload, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getNewsletters')
                successToast(`${response.data.message}`)
                router.push('/glimpses/newsletters')
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // Approve an existing Newsletter
    approveNewsletter({ dispatch, commit }, payload) {

        showLoader(`Approving Newsletter: Vol- ${payload.volume} Issue- ${payload.issue}`);
        api.put(`/glimpses/newsletter/status/${payload._id}`, {status: true}, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getNewsletters')
                successToast(`${response.data.message}`)
                router.push('/glimpses/newsletters')
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // Send an existing Newsletter
    sendNewsletter({ dispatch, commit }, payload) {

        showLoader(`Sending Newsletter: Vol- ${payload.volume} Issue- ${payload.issue}`);
        api.post(`/glimpses/newsletter/send`, {id: payload._id}, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getNewsletters')
                successToast(`${response.data.message}`)
                router.push('/glimpses/newsletters')
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },

    // Notifications CRUD
    // GET all Notifications
    getNotifications({ commit }) {


        showLoader(`Getting Notifications...!`);

        api.get(`/glimpses/notifications`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setNotifications', response.data.data ? response.data.data : [])
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // GET a Notification by id
    getNotification({ commit }, id) {
        api.get(`/glimpses/notifications/${id}`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setNotification', response.data.data ? response.data.data : null)
            })
            .catch(error => handleError(error, false))
    },
    // ADD a Notification
    createNotification({ dispatch, commit }, payload) {


        showLoader(`Creating a notifications: ${payload.title}`);

        api.post(`/glimpses/notifications`, payload, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getNotifications')
                successToast(`${response.data.message}`)
                router.push('/glimpses/notifications')
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // DELETE an existing Notification
    deleteNotification({ dispatch, commit }, payload) {
        let { token, refreshtoken } = getAuthTokens()
        let config = {
            data: { slug: payload },
            headers: { token, refreshtoken },
        }

        showLoader(`Loading...!`);

        api.delete(`/glimpses/notifications/${payload}`, config)
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getNotifications')
                successToast(`${response.data.message}`)
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // UPDATE an existing Notification
    updateNotification({ dispatch, commit }, payload) {


        showLoader(`Updating notifications: ${payload.title}`);

        api.put(`/glimpses/notifications/${payload._id}`, payload, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getNotifications')
                successToast(`${response.data.message}`)
                router.push('/glimpses/notifications')
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // Send  Notification
    sendNotification({ dispatch, commit }, payload) {


        showLoader(`Sending notification: ${payload.title}`);

        api.post(`/glimpses/notifications/now`, payload, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getNotifications')
                successToast(`${response.data.message}`)
                router.push('/glimpses/notifications')
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },

    // Notices CRUD
    // GET all Notices
    getNotices({ commit }) {


        showLoader(`Getting Circulars...!`);

        api.get(`/glimpses/notices/n/2/1`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setNotices', response.data.data ? response.data.data : [])
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // GET a Notice by date
    getNoticeByDate({ commit }, payload) {

        showLoader(`Getting Circulars for ${payload.date}...!`);
        api.post(`/glimpses/notices/n/date`, payload, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setNotices', response.data.data ? response.data.data : null)
                // console.log("getNoticeByDate -> response.data.data", response.data.data)
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // ADD a Notice
    createNotice({ dispatch, commit }, payload) {


        showLoader(`Creating a Circular: ${payload.date}`);

        api.post(`/glimpses/notices/n`, payload, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                // dispatch('getNoticeByDate', {date: payload.date})
                successToast(`${response.data.message}`)
                router.push('/glimpses/notices/manage')
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // DELETE an existing Notice
    deleteNotice({ dispatch, commit }, payload) {
        let { token, refreshtoken } = getAuthTokens()
        let config = {
            data: payload,
            headers: { token, refreshtoken },
        }

        showLoader(`Loading...!`);

        api.delete(`/glimpses/notices/n`, config)
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getNoticeByDate', { date: payload.date })
                successToast(`${response.data.message}`)
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // UPDATE an existing Notice
    updateNotice({ dispatch, commit }, payload) {


        showLoader(`Updating Circulars: ${payload.date}`);

        api.put(`/glimpses/notices/n`, payload, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getNoticeByDate', { date: payload.date })
                successToast(`${response.data.message}`)
                router.push('/glimpses/notices/manage')
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },

    // Todays CRUD
    // GET all Todays
    getTodays({ commit }) {


        showLoader(`Getting Todays...!`);

        api.get(`/glimpses/notices/t/2/1`, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setToday', response.data.data ? response.data.data : [])
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // GET a Today by date
    getTodayByDate({ commit }, payload) {
        showLoader(`Getting Todays for ${payload.date}...!`);
        api.post(`/glimpses/notices/t/date`, payload, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                // structure of data return was changed to pagination style for Mobile Application, because of the working of the Flutter Widget.
                // response.data.data[0].today is work around to get to the data.
                if(response.data.data && response.data.data.length > 0){
                    commit('setToday', response.data.data[0].today)
                }
                else{
                    commit('setToday', [])
                }
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // ADD a Today
    createToday({ dispatch, commit }, payload) {


        showLoader(`Creating a todays: ${payload.date}`);

        api.post(`/glimpses/notices/t`, payload, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                // dispatch('getTodayByDate', {date: payload.date})
                successToast(`${response.data.message}`)
                router.push('/glimpses/today/manage')
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // DELETE an existing Today
    deleteToday({ dispatch, commit }, payload) {
        let { token, refreshtoken } = getAuthTokens()
        let config = {
            data: payload,
            headers: { token, refreshtoken },
        }

        showLoader(`Loading...!`);

        api.delete(`/glimpses/notices/t`, config)
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getTodayByDate', { date: payload.date })
                successToast(`${response.data.message}`)
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },
    // UPDATE an existing Today
    updateToday({ dispatch, commit }, payload) {


        showLoader(`Updating todays: ${payload.date}`);

        api.put(`/glimpses/notices/t`, payload, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                dispatch('getTodayByDate', { date: payload.date })
                successToast(`${response.data.message}`)
                router.push('/glimpses/today/manage')
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },

    // Reports
    // Subscription reports
    getSubscriptionReports({ commit }, payload){
        showLoader(`Getting Subscription Reports...!`);

        let url = ''
        if(payload.user == 'students' || payload.user == 'parents'){
            if(payload.batch != null)
                url = `/glimpses/subscription/${payload.type}/${payload.user}/${payload.batch}`
            else
                url = `/glimpses/subscription/${payload.type}/all/${payload.user}`
        }
        else
            url = `/glimpses/subscription/${payload.type}/all/${payload.user}`

        api.get(url, getHeaders())
            .then(response => {
                commit('setAuthTokens', response.headers)
                commit('setSubscribers', response.data.data ? response.data.data : [])
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },

    // Upload CSV
    uploadCSV({ dispatch, commit }, {type, payload}) {

        let headers = getHeaders()
        headers.headers['Content-Type'] = 'multipart/form-data'

        showLoader(`Uploading CSV ...`);
        api.post(`/admin/users/${type}/csv`, payload, headers)
            .then(response => {
                commit('setAuthTokens', response.headers)
                successToast(`${response.data.message}`)
                hideLoader()
            })
            .catch(error => handleError(error, true))
    },

}